import { z } from 'zod';

// Travel-agent standing discussion link (Main DB).
// PRD: apps/itineraries/prd/customer-preview-discussion.md
// Consultant mint/revoke/meta — raw token is returned only from mint.

export const mintCustomerPreviewAccessLinkInput = z.object({
  itineraryId: z.uuid(),
});
export type MintCustomerPreviewAccessLinkInput = z.infer<
  typeof mintCustomerPreviewAccessLinkInput
>;

export const revokeCustomerPreviewAccessLinkInput = z.object({
  itineraryId: z.uuid(),
});
export type RevokeCustomerPreviewAccessLinkInput = z.infer<
  typeof revokeCustomerPreviewAccessLinkInput
>;

export const getCustomerPreviewAccessLinkMetaInput = z.object({
  itineraryId: z.uuid(),
});
export type GetCustomerPreviewAccessLinkMetaInput = z.infer<
  typeof getCustomerPreviewAccessLinkMetaInput
>;

/** Returned only from mint — includes raw token + full URL once. */
export const mintCustomerPreviewAccessLinkOutput = z.object({
  tokenId: z.uuid(),
  rawToken: z.string().min(1),
  url: z.string().url(),
  itineraryId: z.uuid(),
  createdOn: z.string(),
});
export type MintCustomerPreviewAccessLinkOutput = z.infer<
  typeof mintCustomerPreviewAccessLinkOutput
>;

/**
 * Active link metadata for consultant UI — never re-exposes raw token.
 * `hasLiveLink` false when never minted or after revoke.
 */
export const customerPreviewAccessLinkMetaOutput = z.object({
  itineraryId: z.uuid(),
  hasLiveLink: z.boolean(),
  tokenId: z.uuid().nullable(),
  createdOn: z.string().nullable(),
  lastUsedAt: z.string().nullable(),
  createdByAccountId: z.uuid().nullable(),
});
export type CustomerPreviewAccessLinkMetaOutput = z.infer<
  typeof customerPreviewAccessLinkMetaOutput
>;

export const revokeCustomerPreviewAccessLinkOutput = z.object({
  itineraryId: z.uuid(),
  revoked: z.boolean(),
});
export type RevokeCustomerPreviewAccessLinkOutput = z.infer<
  typeof revokeCustomerPreviewAccessLinkOutput
>;
